<template>
    <div class="blackjack">
        <div v-if="isMobile" class="blackjack-mobile-message">
            <div class="blackjack-mobile-message-inner">
                <div class="blackjack-mobile-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                    </svg>
                </div>
                <h2 class="blackjack-mobile-title">Not available on mobile</h2>
                <p class="blackjack-mobile-text">This game is not available on mobile. Please use iPad or PC to play Blackjack.</p>
            </div>
        </div>
        <transition v-else name="slide-fade" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    const MOBILE_MAX_WIDTH = 767;

    export default {
        name: 'Blackjack',
        metaInfo: {
            title: 'Blackjack'
        },
        data() {
            return {
                isMobile: false
            };
        },
        methods: {
            ...mapActions([
                'socketConnectBlackjack',
                'socketDisconnectBlackjack',
                'notificationShow'
            ]),
            checkMobile() {
                const mobile = typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX_WIDTH;
                if (mobile !== this.isMobile) {
                    this.isMobile = mobile;
                    if (mobile) {
                        this.notificationShow({
                            type: 'error',
                            message: 'This game is not available on mobile. Please use iPad or PC.'
                        });
                    }
                }
            }
        },
        created() {
            this.checkMobile();
            if (!this.isMobile) {
                this.socketConnectBlackjack();
            }
        },
        mounted() {
            window.addEventListener('resize', this.checkMobile);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile);
        },
        beforeRouteLeave(to, from, next) {
            if (!this.isMobile) {
                this.socketDisconnectBlackjack();
            }
            next();
        }
    }
</script>

<style scoped>
    .blackjack {
        width: 100%;
        position: relative;
        min-height: 100vh;
    }

    .blackjack .slide-fade-enter-active {
        transition: all .3s ease-out;
    }

    .blackjack .slide-fade-enter {
        opacity: 0;
    }

    .blackjack-mobile-message {
        width: 100%;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        box-sizing: border-box;
        background: var(--bg-table-background, #1a1b2e);
    }

    .blackjack-mobile-message-inner {
        max-width: 400px;
        text-align: center;
        padding: 40px 32px;
        background: var(--bg-blue-dark, rgba(255, 255, 255, 0.06));
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 20px;
    }

    .blackjack-mobile-icon {
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 20px;
    }

    .blackjack-mobile-title {
        font-size: 22px;
        font-weight: 700;
        color: #ffffff;
        margin: 0 0 12px 0;
    }

    .blackjack-mobile-text {
        font-size: 15px;
        line-height: 1.5;
        color: rgba(255, 255, 255, 0.8);
        margin: 0;
    }
</style>
